import { default as Card, default as CardText } from '@material-ui/core/Card';
import React from 'react';
import { Title } from 'react-admin';

export default () => (
  <Card>
    <Title title="Not Found" />
    <CardText>
      <h1>404: Page not found</h1>
    </CardText>
  </Card>
);



// WEBPACK FOOTER //
// ./src/NotFound.js